import api from '../../services/api';
import { sanitizeForLog } from '../../utilities/logSanitizer';
import { buildApiHeaders } from '../../utilities/configUtils';

export interface FetchNotificationTypeResponseValues {
  Id: number;
  Name: string;
}

export interface FetchNotificationTypeResponse {
  Id: string;
  DateCreated: string;
  Values: FetchNotificationTypeResponseValues[];
}

const fetchNotificationTypeNameAsync = async () => {
  try {
    return await api
      .get('notificationTypes', {
        headers: {
          'content-type': 'application/json',
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data as FetchNotificationTypeResponse;
        } else {
          const safeData = sanitizeForLog(JSON.stringify(response.data));
          console.error('Unexpected response format:', safeData);
          return null;
        }
      });
  } catch (error) {
    console.error('Error fetching notification list:', error);
    return [];
  }
};

const fetchNotificationsInitialState = async (notificationURL: string, signal?: AbortSignal) => {
  try {
    const headers = await buildApiHeaders();
    return await api
      .get(notificationURL, {
        headers,
        signal,
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      });
  } catch (error) {
    console.error('Error fetching notification list:', error);
    return [];
  }
};

export { fetchNotificationTypeNameAsync, fetchNotificationsInitialState };
